import React from 'react';
import {Clock, Video} from "lucide-react";
import ContentTypeDropdown from "./ContentTypeDropDown";
import LanguageDropdown from "./LanguageDropdown";
import VoiceDropdown from "./VoiceDropdown";
import YoutubeIcons from "../../../YoutubeIcon";
import ArtStyleSelector from "../../../ArtStylesSelector";
import PromptExamples from "./PromptExamples";

const CreateSeriesForm = ({languages ,handleChange,isGeneratingPreview,voices,handlePreviewClick,themes,previewGenerated,handleOptionSelect, setShowingPreview,handlePlatformToggle,seriesData,publishTime,handlePublishTimeChange}) => {
    const platforms = [
        {
            name: 'YouTube Shorts',
            icon: YoutubeIcons,
        },
        { name: 'TikTok', icon: Video },
        // { name: 'Instagram', icon: Video },
    ];
    return  <div className="max-w-4xl mx-auto p-6 space-y-8">
            {/* Platforms */}
            <div>
                <h5 className="text-lg font-medium mb-3 text-gray-700">
                    Platforms
                </h5>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    {
                        platforms.map((platform) => (
                        <button
                            key={platform.name}
                            type="button"
                            onClick={() => handlePlatformToggle(platform.name)}
                            className={`
            flex items-center p-4 rounded-lg 
            ${
                                seriesData.platforms.includes(platform.name)
                                    ? 'bg-indigo-100 text-indigo-700'
                                    : 'bg-gray-100 text-gray-700'
                            } 
            hover:bg-indigo-200 transition-colors duration-300
          `}
                        >
                            <platform.icon
                                size={24}
                                className="w-5 h-5 mr-2"
                                color={
                                    platform.name === 'YouTube Shorts'
                                        ? seriesData.platforms.includes(platform.name)
                                            ? "#FF0000" // Red when selected
                                            : "#A0AEC0" // Gray when not selected
                                        : "#A0AEC0" // Default color for other icons
                                }
                            />
                            {platform.name}
                        </button>
                    ))}
                </div>
            </div>
            {/* Content Type and Language */}
            <div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Content Type */}
                    <div>
                        <h5 className="text-lg font-medium mb-3 text-gray-700">
                            Content Type
                        </h5>
                        <ContentTypeDropdown
                            seriesData={seriesData}
                            themes={themes}
                            onSelectOption={(option) => handleOptionSelect('contentType', option)}
                        />
                        {seriesData.contentType === 'Custom Topic' && (
                            <>
                            <input
                                type="text"
                                name="customTopic"
                                value={seriesData.customTopic}
                                onChange={handleChange}
                                className="mt-3 w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                placeholder="Enter your custom topic"
                            />
                            <PromptExamples />
                            </>
                        )}
                    </div>

                    {/* Language */}
                    <div>
                        <h5 className="text-lg font-medium mb-3 text-gray-700">
                            Language
                        </h5>
                        <LanguageDropdown
                            seriesData={seriesData}
                            languages={languages}
                            onSelectOption={(option) => handleOptionSelect('language', option)}
                        />
                    </div>
                </div>
            </div>
        {/* Art Style */}
        <ArtStyleSelector
            selectedStyle={seriesData.artStyle}
            onSelectStyle={(style) => handleOptionSelect('artStyle', style)}
        />

        {/* Voice and Duration */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Voice */}
                <div>
                    <h5 className="text-lg font-medium mb-3 text-gray-700">
                        Voice
                    </h5>
                    <VoiceDropdown
                        seriesData={seriesData}
                        voices={voices}
                        onSelectOption={(option) => handleOptionSelect('voice', option)}
                    />
                </div>

                {/* Video Duration */}
                <div>
                    <h5 className="text-lg font-medium mb-3 text-gray-700">
                        Video Duration
                    </h5>
                    <div className="grid grid-cols-2 gap-4">
                        {[
                            { display: '30-60', value: 1 },
                            // { display: '60-90', value: 2 },
                        ].map((durationOption) => (
                            <button
                                key={durationOption.display}
                                type="button"
                                onClick={() => handleOptionSelect('duration', durationOption.value)}
                                className={`
                                    flex items-center p-4 rounded-lg 
                                    ${seriesData.duration === durationOption.value
                                    ? 'bg-indigo-100 text-indigo-700'
                                    : 'bg-gray-100 text-gray-700'
                                } 
                                    hover:bg-indigo-200 transition-colors duration-300
                                `}
                            >
                                <Clock className="w-5 h-5 mr-2" />
                                {durationOption.display} seconds
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            {/* Publish Time */}
            <div>
                <h5 className="text-lg font-medium mb-3 text-gray-700">
                    Publish Time
                </h5>
                <div className="flex items-center">
                    <Clock className="w-5 h-5 mr-2 text-gray-500" />
                    <input
                        type="time"
                        value={`${publishTime.hour.toString().padStart(2, '0')}:${publishTime.minute.toString().padStart(2, '0')}`}
                        onChange={handlePublishTimeChange}
                        className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                </div>
            </div>
            {/* Action Buttons */}
            <div className="flex justify-center gap-4 pt-4">
                {previewGenerated && (
                    <button
                        type="button"
                        onClick={() => setShowingPreview(true)}
                        className="px-6 py-3 rounded-lg border border-indigo-600 text-indigo-600 hover:bg-indigo-50"
                    >
                        Back to Preview
                    </button>
                )}
                <button
                    type="button"
                    onClick={handlePreviewClick}
                    disabled={isGeneratingPreview}
                    className="px-6 py-3 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50"
                >
                    {isGeneratingPreview
                        ? 'Generating...'
                        : previewGenerated
                            ? 'Regenerate Preview'
                            : 'Generate Preview'
                    }
                </button>
            </div>
        </div>
};

export default CreateSeriesForm;
